<template>
    <VJoyDialog
        ref="clientOpsConfirmationModal"
        data-testid="project-validation-client-ops-confirmation-modal"
        open
        pattern-confirm
        :cancel-text="t('generic.form.cancel.label')"
        @dialog:confirm="confirmClientOpsAction"
        @dialog:hide="emit('close:dialog')"
    >
        <template #dialog-header>
            {{ header }}
        </template>
        <template #dialog-body>
            {{ message }}
            <VJoyTextarea v-model="comment" data-testid="project-validation-confirmation-explanation-input" />
        </template>
        <template #dialog-confirm>
            <VJoyButton
                data-testid="project-validation-confirmation-button"
                :loading="isUpdating"
                variant="main"
                :label="t('generic.form.confirm.label')"
                :disabled="!comment"
                @click="confirmClientOpsAction"
            />
        </template>
    </VJoyDialog>
</template>

<script setup lang="ts">
    import {onBeforeMount, useTemplateRef} from 'vue';
    import {useTranslation} from '#imports';
    import {VJoyDialog, VJoyTextarea, VJoyButton} from '@maltjoy/core-vue';

    const {t} = useTranslation();

    defineProps<{
        header: string;
        message: string;
        isUpdating?: boolean;
    }>();

    const emit = defineEmits<{
        'confirm:action': [];
        'close:dialog': [];
    }>();

    const clientOpsConfirmationModal = useTemplateRef('clientOpsConfirmationModal');

    const comment = defineModel<string>('modelValue');

    function confirmClientOpsAction() {
        emit('confirm:action');
        emit('close:dialog');
    }

    // clear comment on open not close; to avoid race condition with `confirm` function
    onBeforeMount(() => {
        comment.value = '';
    });
</script>

<style lang="scss" scoped>
    :deep(.joy-textarea_wrapper) {
        margin-top: var(--joy-core-spacing-4);
    }
</style>
